<div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="16px">
  <div>
    <p [ngStyle]="{ marginBottom: '4px' }">
      <b i18n="@@settingsScreenRecording.shareUsageInfo"
        >Share usage information with 10KC</b
      >
    </p>
    <p
      class="color-grey-300 u-text-maxWidth u-marginBottom-8"
      i18n="@@settingsScreenRecording.shareUsageDescription"
    >
      Help 10KC improve our platform and provide tailored support by sharing
      usage information. About
      <a
        appZendeskLink
        class="u-textDecoration-underline--hover color-blue"
        href="https://support.tenthousandcoffees.com/hc/articles/23145597100308"
        rel="noopener noreferrer"
        target="_blank"
        >sharing usage information</a
      >...
    </p>
    <ul [ngStyle]="{ listStyle: 'none' }" class="color-grey-300">
      <li
        [ngStyle]="{ marginBottom: '4px' }"
        i18n="@@settingsScreenRecording.privacyPromiseDescription"
      >
        🔒 Privacy Promise: We prioritize your privacy and data security at
        every step.
      </li>
      <li i18n="@@settingsScreenRecording.supportDescription">
        💬 Support: Have more questions?
        <button
          (click)="showZendesk()"
          class="c-button color-blue u-textDecoration-underline--hover"
        >
          Send us a message</button
        >.
      </li>
    </ul>
  </div>
  <nz-switch
    [disabled]="isLoading || isTenThousandCoffeesAdmin"
    [nz-tooltip]="isTenThousandCoffeesAdmin ? internalAdminToolTip : ''"
    [nzLoading]="isLoading"
    [(ngModel)]="optedIntoScreenRecording"
    (ngModelChange)="saveChange(optedIntoScreenRecording)"
  ></nz-switch>
  <ng-template #internalAdminToolTip>
    <ng-container i18n="@@settingsScreenRecoring.autoEnabledFor10KC"
      >This is auto-enabled for 10KC employees.</ng-container
    >
  </ng-template>
</div>
